import { Injectable, inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";

export interface PaymentSettings {
  hotel_enabled: boolean;
  paypal_enabled: boolean;
  default: "hotel" | "paypal";
  paypal_client_id: string;
  paypal_secret_set: boolean;
  paypal_mode: "sandbox" | "live";
  methods: { hotel: boolean; paypal: boolean; default: string };
  return_url: string;
}

export interface PaymentSettingsInput {
  hotel_enabled: boolean;
  paypal_enabled: boolean;
  default: string;
  paypal_client_id: string;
  paypal_secret: string;
  paypal_mode: string;
}

@Injectable({ providedIn: "root" })
export class PaymentSettingsService {
  private http = inject(HttpClient);
  private url = `${environment.baseUrl}/settings/payments`;

  get(): Observable<PaymentSettings> {
    return this.http.get<PaymentSettings>(this.url);
  }

  save(input: PaymentSettingsInput): Observable<PaymentSettings> {
    return this.http.post<PaymentSettings>(this.url, input);
  }

  test(): Observable<{ ok: boolean }> {
    return this.http.post<{ ok: boolean }>(`${this.url}/test`, {});
  }
}
